import Api from '../../common/api';

const irsApi = Api.getApiIRS();

export async function requestGetApplications() {
  const response = await irsApi.request('get', '/applications');
  const { data, metadata } = response;
  return { data, metadata };
}
